import { NgModule, CUSTOM_ELEMENTS_SCHEMA } from '@angular/core';
import { CommonModule } from '@angular/common';
import { PolymerModule } from '@codebakery/origami';
import { LayoutComponent } from './layout/layout.component';
import { UploadHistoryZipComponent } from './upload-history-zip/upload-history-zip.component';
import { AzureBlobUploadService } from '../context-discovery-services/services/azure-blob-upload.service';
import { PointService } from '../context-discovery-services/services';
import { UploadHistoryModalComponent } from './upload-history-modal/upload-history-modal.component';
import { PublishHistoryModalComponent } from './publish-history-modal/publish-history-modal.component';
import { HistoryConfigComponent } from './history-config/history-config.component';
import { EventLoggerService } from '../context-discovery-services/services/event-logger.service';

@NgModule({
  imports: [
    CommonModule,
    PolymerModule
  ],
  schemas: [CUSTOM_ELEMENTS_SCHEMA],
  exports: [LayoutComponent],
  declarations: [LayoutComponent, UploadHistoryZipComponent, UploadHistoryModalComponent, PublishHistoryModalComponent
    , HistoryConfigComponent],
  providers: [AzureBlobUploadService, PointService, EventLoggerService]
})
export class UploadHistoryModule { }
